<template>
    <div class="t-profile-child__container t-profile__box">
        <h2 class="t-profile-child__title">{{ $root.staticText.lk.securityTitle }}</h2>
        <form class="t-profile-child__form t-form" @submit.stop.prevent="submit()">
            <div
                class="t-form__item _half-lk"
                v-for="(item, index) in form"
            >
                <div v-if="item.label" class="t-form__label">
                    {{ item.label }}
                    <span v-if="item.required">*</span>
                </div>

                <input
                    v-if="item.type === 'password'"
                    class="t-input"
                    :class="{'_error': item.error, '_valid': item.valid}"
                    :type="item.type"
                    :placeholder="item.hintField"
                    v-model="item.value"
                    @focus="focus(index)"
                />
            </div>

            <div class="t-profile-child__text">{{ $root.staticText.lk.securityText }}</div>
            <div class="t-profile-child__block">
                {{ $root.staticText.lk.securitySubtext }}
                <span
                    @click="modalType_requestOpen({
                        options: $parent.optionsRequest,
                        button: $root.staticText.forms.btn
                    })"
                    class="t-profile-child__block-link"
                >
                    {{ $root.staticText.lk.securitySubtext2 }}
                </span>
                {{ $root.staticText.lk.securitySubtext3 }}
                <a
                    :href="'mailto:' + $parent.securityEmail"
                    class="t-profile-child__block-link"
                >
                    {{ $parent.securityEmail }}
                </a>
            </div>

            <vue-recaptcha
                ref="recaptcha"
                size="invisible"
                :sitekey="$root.sitekeyRecaptcha"
                :load-recaptcha-script="true"
                @verify="onCapchaRegister"
                @expired="onCaptchaExpired"
                @error="errorCaptcha"
            />
            <button class="t-btn _lk _green t-profile-child__btn t-form__btn" :class="{_disabled: disabledBtn}">
                {{ $root.staticText.lk.securityBtn }}
            </button>
        </form>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import Vue from "vue";
    import VueRecaptcha from "vue-recaptcha";

    export default {
        name: "security",
        data() {
            return {
                recaptchaToken: null,
                isValid: false,
                form: [
                    {
                        label: this.$root.staticText.lk.password,
                        name: 'password',
                        type: 'password',
                        value: '',
                        hintField: this.$root.staticText.lk.placeholderPassword,
                        error: false,
                        valid: false,
                        required: true,
                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-zА-Яа-я\d]{8,}$/,
                    },
                    {
                        label: this.$root.staticText.lk.passwordRepeat,
                        name: 'passwordRepeat',
                        type: 'password',
                        value: '',
                        hintField: this.$root.staticText.lk.placeholderPasswordRepeat,
                        error: false,
                        valid: false,
                        required: true,
                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-zА-Яа-я\d]{8,}$/,
                    },
                ],
                disabledBtn: false,
            }
        },
        components: {
            VueRecaptcha,
        },
        methods: {
            ...mapActions('modal', [
                'modalType_lkSuccessOpen',
                'modalType_lkErrorOpen',
                'modalClose',
                'modalType_requestOpen'
            ]),

            onCapchaRegister(recaptchaToken) {
                this.recaptchaToken = recaptchaToken;
                if (this.isValid) {
                    this.sendForm();
                }
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset();
            },
            errorCaptcha() {
                console.log('errorCaptcha');
            },

            validate() {
                let is_valid = true;

                for (let i = 0; i < this.form.length; i++) {
                    this.form[i].error = false;
                    this.form[i].valid = true;

                    if (
                        this.form[i].pattern !== '' &&
                        (!this.form[i].required ? this.form[i].value !== '' : true)
                    ) {
                        if (!this.form[i].pattern.test(this.form[i].value.trimEnd())) {
                            this.form[i].error = true;
                            this.form[i].valid = false;
                            is_valid = false;
                        }
                    }

                    if (this.form[i].name === 'passwordRepeat') {
                        if (this.form[i].value !== this.form[i - 1].value) {
                            this.form[i].error = true;
                            this.form[i].valid = false;
                            is_valid = false;
                        }
                    }
                }

                this.isValid = is_valid;
            },
            submit() {
                this.validate();

                if (this.isValid) {
                    this.$refs.recaptcha.execute();
                }
            },
            sendForm() {
                this.disabledBtn = true;
                let fd = new FormData();
                fd.append('recaptchaToken', this.recaptchaToken);

                for (let i = 0; i < this.form.length; i++) {
                    fd.append(this.form[i].name, this.form[i].value);
                }

                let action = process.env.NODE_ENV !== 'production' ? 'lk/logout.json' : 'lk/newPassword';
                let methods = process.env.NODE_ENV !== 'production' ? 'get' : 'post';

                Vue.http[methods](action, fd)
                    .then(response => response.json())
                    .then((data) => {
                        this.disabledBtn = false;

                        if (data.success) {
                            this.modalType_lkSuccessOpen({
                                title: this.$root.staticText.lk.successText,
                                closeBthNone: true
                            });
                        } else {
                            this.openError(data);
                        }
                    })
                    .catch((data) => {
                        this.disabledBtn = false;
                        this.openError(data);
                    });
            },
            openError(data) {
                let text = this.$root.staticText.lk.lkErrorText;
                if (data.errors && data.errors.length > 0) {
                    let key = Object.keys(data.errors)[0];
                    if (data.errors[key][0]) {
                        text = data.errors[key][0];
                    }
                }
                this.modalType_lkErrorOpen({
                    title: this.$root.staticText.lk.lkErrorTitle,
                    text: text,
                    closeBthNone: true
                });
            },
            focus(i) {
                this.form[i].error = false;
            },
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/pages/lk/profile/security/index.vue